// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__snGsj","description":"PatientConsentPreview_description__ffsve"};